// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar .centerButtons button {
  width: 35px;
}

ion-toolbar .centerButtons {
  text-align: center;
}

.cropperClose .closeIcon {
  top: inherit !important;
}

ion-button {
  width: auto;
  height: auto;
  --background: transparent;
  --box-shadow: none;
}

ion-button::part(native) {
  padding: 0px 5px !important;
}

.cropperContent ion-icon {
  color: #fff;
}

.cropperContent img {
  max-width: 100%;
  max-height: 100%;
}

.toolbar-save {
  height: 48px;
  background-color: #222428;
  padding: 10px 0px;
  text-align: end;
  min-height: 55px;
}

.toolbar-edit {
  height: 55px;
  padding: 5px 0px;
  background-color: #222428;
  text-align: center;
  min-height: 55px;
  position: fixed;
  color: #fff;
  width: 100%;
  bottom: 35px;
}

.toolbar-save ion-icon {
  color: #BE1E2D !important;
  font-weight: bold;
  font-size: 25px !important;
}

.toolbar-edit ion-icon {
  color: #fff;
  font-weight: bold;
  font-size: 25px !important;
}

.account-setting {
  margin-top: calc(60px + env(safe-area-inset-top)) !important;
  padding: 0 0 0 0px;
}

.complete-sign-up {
  margin-top: calc(0px + env(safe-area-inset-top)) !important;
  padding: 0 0 0 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/_layout/imagecropper/imagecropper.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACG,WAAA;AACH;;AAEA;EACG,eAAA;EACA,gBAAA;AACH;;AAEA;EACI,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,iBAAA;EACA,0BAAA;AACJ;;AACA;EACI,WAAA;EACA,iBAAA;EACA,0BAAA;AAEJ;;AAAA;EACI,4DAAA;EACA,kBAAA;AAGJ;;AAAA;EACI,2DAAA;EACA,kBAAA;AAGJ","sourcesContent":["ion-toolbar .centerButtons button {\n    width: 35px;\n}\n\nion-toolbar .centerButtons {\n    text-align: center;\n}\n\n.cropperClose .closeIcon {\n    top: inherit !important;\n}\n\nion-button{\n    width: auto;\n    height: auto;\n    --background: transparent;\n    --box-shadow : none;\n}\n\nion-button::part(native) {\n    padding: 0px 5px !important;\n}\n\n.cropperContent ion-icon{\n   color: #fff;\n}\n\n.cropperContent img{\n   max-width: 100%;\n   max-height: 100%;\n}\n\n.toolbar-save{\n    height: 48px;\n    background-color: #222428;\n    padding: 10px 0px;\n    text-align: end;\n    min-height: 55px;\n}\n\n.toolbar-edit{\n    height: 55px;\n    padding: 5px 0px;\n    background-color: #222428;\n    text-align: center;\n    min-height: 55px;\n    position: fixed;\n    color: #fff;\n    width: 100%;\n    bottom: 35px;\n}\n\n.toolbar-save ion-icon{\n    color: #BE1E2D!important;\n    font-weight: bold;\n    font-size: 25px!important;\n}\n.toolbar-edit ion-icon{\n    color: #fff;\n    font-weight: bold;\n    font-size: 25px!important;\n}\n.account-setting{\n    margin-top:  calc(60px + env(safe-area-inset-top)) !important;\n    padding: 0 0 0 0px;\n}\n\n.complete-sign-up{\n    margin-top:  calc(0px + env(safe-area-inset-top)) !important;\n    padding: 0 0 0 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
